export default {
  viewBox: "0 0 24 24",
  html: "<path fill-rule=\"evenodd\" d=\"M14 13v-2h8v2zm0-6v2h6V7zm8 10v-2h-8v2zm-10-1c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V8c0-1.1.9-2 2-2h6c1.1 0 2 .9 2 2z\"/>"
};